import { useEffect } from 'react';
import PageLayout from '@/components/PageLayout';
import SolarSumPc from '@/components/solarSumPage';
import SolarSumH5 from '@/componentsH5/solarSumPage';
import { isReadyLang, redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { getCategoryList } from '@/service';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/collections/solar-generators';
import { redirect } from 'next/dist/server/api-utils';
import { destination } from 'pino';

export default function SolarSumPage({ isMobile, SEO, categories, data }: any) {
    const { useRouter, useState, gtm } = useGlobal();
    const router = useRouter();
    const [pageLeady, setPageLeady] = useState(false);
    const SolarSum = !isMobile ? SolarSumPc : SolarSumH5;
    const productMap = !isMobile ? data.pc : data.h5;
    const { locale } = router;

    useEffect(() => {
        if (typeof window === 'undefined') return;
        setPageLeady(true);
        gtm.EmPush(['category', 'Solar Panels']);
        if (locale !== 'us') {
            window.open(`https://${locale}.ecoflow.com/pages/solar-panels`, '_blank');
        }
    }, []);

    return (
        <PageLayout theme="gray">
            <SEO
                title="Solar Powered Generators: Eco-Friendly Backup Power"
                description="Stay powered up with our solar-powered generators. Perfect for outdoor adventures or emergency backup. Shop now for reliable, eco-friendly energy solutions."
            />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            {pageLeady && <SolarSum categoryList={categories} productMap={productMap} />}
        </PageLayout>
    );
}

export async function getServerSideProps(serviceProps: any) {
    const { locale } = serviceProps;

    if (locale !== 'en') {
        if (!isReadyLang(locale)) {
            return redirectTo404();
        }
    }

    let collectionData = null;
    try {
        collectionData = require(`@/data/collection/${locale}`);
    } catch (e) {
        collectionData = require(`@/data/collection/en`);
    }

    let categories: any = null;
    try {
        const resCategory = await getCategoryList(locale);
        if (resCategory.code === '0') {
            categories = resCategory?.data;
        }
    } catch (err) {
        console.log(err);
    }

    if (['us', 'uk'].includes(locale)) {
        return {
            redirect: {
                destination: '/' + locale,
                parmanent: true,
            },
        };
    }

    // 需求修改当前页面us做301重定向到shopify页面
    if (locale === 'us') {
        return {
            redirect: {
                destination: 'https://us.ecoflow.com/collections/solar-generators',
                parmanent: true,
            },
        };
    }
    // 需求修改当前页面us做301重定向到shopify页面
    if (locale === 'jp') {
        return {
            redirect: {
                destination: 'https://jp.ecoflow.com/collections/delta-series-solar-generators',
                parmanent: true,
            },
        };
    }

    return {
        props: {
            data: {
                pc: collectionData(false),
                h5: collectionData(true),
            },
            categories,
        },
    };
}
